import { StyleSheet } from 'react-native';
import theme from '../../common/theme';
import { themeType } from '../../common/theme-colors';

export const makeStyles = (colors: themeType) =>
  StyleSheet.create({
    container: {
      width: 240,
      backgroundColor: colors.popupBg,
    },
    button: {
      width: 44,
      height: 44,
      marginLeft: 6,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: theme.radius.small,
      marginTop: 8,
    },
    marker: {
      position: 'absolute',
      top: 6,
      right: 6,
      width: 12,
      height: 12,
      borderRadius: 10,
      backgroundColor: colors.states.positive,
      zIndex: 1,
    },
    optionsBg: {
      padding: 10,
      paddingBottom: 0,
      borderRadius: theme.radius.small,
      backgroundColor: colors.popupBg,
      ...theme.shadow.light,
    },
    option: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingLeft: 10,
      marginBottom: 10,
    },
    text: {
      flex: 1,
      fontSize: 14,
      lineHeight: 20,
      fontFamily: theme.fonts.medium,
      color: colors.text,
    },
    icon: {
      width: 38,
      height: 38,
      alignItems: 'center',
      justifyContent: 'center',
    },
    bgStyle: {
      width: '100%',
      height: theme.deviceHeight,
      position: 'absolute',
      backgroundColor: colors.transparent,
    },
    optionsContainer: {
      width: 260,
      maxWidth: 260,
      backgroundColor: colors.popupBg,
      borderRadius: theme.radius.small,
      marginBottom: 10,
    },
    arrowStyle: {
      backgroundColor: colors.popupBg,
    },
  });
